import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { registerUserScopedClientStateCleaner } from '../services/clientSessionLifecycle';

const UnreadMessagesContext = createContext(null);

export const UnreadMessagesProvider = ({ children }) => {
    const [totalUnread, setTotalUnread] = useState(0);
    const [totalGroupUnread, setTotalGroupUnread] = useState(0);
    const [pendingFriendRequests, setPendingFriendRequests] = useState(0);

    const clearUnreadState = useCallback(() => {
        setTotalUnread(0);
        setTotalGroupUnread(0);
        setPendingFriendRequests(0);
    }, []);

    useEffect(
        () => registerUserScopedClientStateCleaner(clearUnreadState),
        [clearUnreadState],
    );

    const value = useMemo(() => ({
        totalUnread,
        setTotalUnread,
        totalGroupUnread,
        setTotalGroupUnread,
        pendingFriendRequests,
        setPendingFriendRequests,
    }), [totalUnread, totalGroupUnread, pendingFriendRequests]);

    return (
        <UnreadMessagesContext.Provider value={value}>
            {children}
        </UnreadMessagesContext.Provider>
    );
};

export const useUnreadMessages = () => {
    const context = useContext(UnreadMessagesContext);
    if (!context) {
        throw new Error('useUnreadMessages must be used within an UnreadMessagesProvider');
    }
    return context;
};
